function CloseCircleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clip-path="url(#clip0_47150_153941)">
        <path
          d="M8.5 0C4.07837 0 0.5 3.57803 0.5 8C0.5 12.4217 4.07803 16 8.5 16C12.9216 16 16.5 12.422 16.5 8C16.5 3.57834 12.922 0 8.5 0ZM8.5 14.75C4.76925 14.75 1.75 11.731 1.75 8C1.75 4.26922 4.76897 1.25 8.5 1.25C12.2308 1.25 15.25 4.26897 15.25 8C15.25 11.7308 12.231 14.75 8.5 14.75Z"
          fill="#0F0B28"
          fill-opacity="0.2"
        />
        <path
          d="M11.2353 9.85145L9.38215 7.99826L11.2353 6.14507C11.4794 5.90101 11.4794 5.50529 11.2354 5.2612C10.9912 5.0171 10.5955 5.01713 10.3515 5.2612L8.49827 7.11438L6.64505 5.2612C6.40102 5.0171 6.00524 5.0171 5.76118 5.2612C5.51712 5.50529 5.51712 5.90101 5.76121 6.14507L7.6144 7.99826L5.76121 9.85145C5.51712 10.0955 5.51709 10.4913 5.76118 10.7353C6.00534 10.9794 6.40105 10.9794 6.64505 10.7353L8.49827 8.88213L10.3515 10.7353C10.5955 10.9794 10.9913 10.9794 11.2354 10.7353C11.4795 10.4912 11.4794 10.0955 11.2353 9.85145Z"
          fill="#0F0B28"
          fill-opacity="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_47150_153941">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CloseCircleIcon;
